/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
import React from "react";
import SpecialPermissionAddEmployeesApp from "../Functionality/SpecialPermissionAddEmployeesApp";
import CustomAvailableItems from "../../../../../../../components/CustomAvailableAssignedItems/CustomAvailableItems";
import {IconChipMultiplePerson, IconDocumentLinedGrid} from "../../../../../../../components/buttons/IconButtons";
import {GetSpecialPermissionNotAssigned} from "../../../../../../../reduxToolkit/UserSpecialPermission/UserSpecialPermissionApi";
import {
    SEARCH_MODEL
} from "../../../../../../../components/table/Model/TableModel";
import {VIEW_TYPE} from "../../../../../../../enums/ViewType";

const SpecialPermissionAddEmployees = (props) => {
    const {
        setBodyForExport,
        results,
        setResults,
        searchElement,
        setSearchElement,
        setSearch,
        setSimpleSearch,
        modified,
        setModified,
        registerAction,
        selected,
        setSelected
    } = props;

    SpecialPermissionAddEmployeesApp({
        selected,
        setSelected,
        registerAction,
        setModified
    });


    return (
        <CustomAvailableItems
            setBodyForExport={setBodyForExport}
            results={results}
            setResults={setResults}
            searchElement={searchElement}
            setSearchElement={setSearchElement}
            setSearch={setSearch}
            setSimpleSearch={setSimpleSearch}
            modified={modified}
            setModified={setModified}
            selected={selected}
            setSelected={setSelected}
            tableIconTitle={<IconDocumentLinedGrid height={16} width={16} className={"mr-8px mb-1 icon-color-general-950"}/>}
            selectedSectionIconTitle={<IconChipMultiplePerson height={18} width={18} className={"mr-8px mb-1 icon-color-general-950"}/>}
            labelRowsPerPage={"employees_per_page"}
            tableNotInformationLegend={'you_have_not_created_any_employee_yet'}
            selectedSectionNotInformationLegend={'no_items_added_yet'}
            tableBuildBody={({ page, rowsPerPage, searchElement }) => SEARCH_MODEL.setObject({ page: page, size: rowsPerPage, key: searchElement }) }
            tableEndPoint={GetSpecialPermissionNotAssigned}
            keyId={"userId"}
            viewTypeName={VIEW_TYPE.GRID.name}
        />
    );

}

export default SpecialPermissionAddEmployees
